export default "__VITE_ASSET__CabqNVL5__"